let baseEventTypesPartOne = [
  // login
  'Logged in',
  // user
  'User list requested',
  'User created',
  'User requested',
  'User updated',
  'User deleted',
  // keystore
  'KeyStore list requested',
  'KeyStore created',
  'KeyStore activated',
  'KeyStore deactivated',
  'KeyStore requested',
  'KeyStore entries requested',
  'KeyStore names requested',
  'KeyStore deleted'
]

export default baseEventTypesPartOne
